import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { API_BASE_URL, getAuthHeaders } from "../../../utils/api";
import "./CourseCampusHub.css";

function CourseCampusHub({ readOnly = false }) {
  const { campusId } = useParams();
  const navigate = useNavigate();
  const [canChangeCampus, setCanChangeCampus] = useState(false);

  // Users scoped to a single campus reach this page directly, so offering
  // "Change Campus" would just bounce them back here.
  useEffect(() => {
    let alive = true;
    fetch(`${API_BASE_URL}/api/campuses`, { headers: getAuthHeaders() })
      .then((res) => (res.ok ? res.json() : []))
      .then((data) => {
        if (alive) setCanChangeCampus((Array.isArray(data) ? data : []).length > 1);
      })
      .catch(() => {
        if (alive) setCanChangeCampus(false);
      });
    return () => {
      alive = false;
    };
  }, []);

  return (
    <div className="course-hub-page">
      <div className="course-hub-header">
        {canChangeCampus && (
          <button
            className="course-hub-back"
            onClick={() => navigate("/teachers/courses")}
          >
            ← Change Campus
          </button>
        )}
        <h2>{readOnly ? "Course & Class Assignments" : "Course Management"}</h2>
      </div>

      <div className="course-hub-grid">
        {!readOnly && (
          <button
            className="course-hub-card"
            onClick={() => navigate(`/teachers/courses/campus/${campusId}/add`)}
          >
            <div className="course-hub-card-title">Add Course</div>
            <p>Pick a class and create a new course for it.</p>
          </button>
        )}

        <button
          className="course-hub-card"
          onClick={() =>
            navigate(`/teachers/courses/campus/${campusId}/assign`)
          }
        >
          <div className="course-hub-card-title">
            {readOnly ? "View Teacher Assignments" : "Assign Course"}
          </div>
          <p>
            {readOnly
              ? "View courses and classes assigned to each teacher."
              : "Assign an existing course to a teacher."}
          </p>
        </button>
      </div>
    </div>
  );
}

export default CourseCampusHub;
